import React from 'react';

import { Action, Actions } from '@gogame/components';
import { useScreenState } from '@gogame/screens';

import { CAMPAIGN_IDS } from 'scenes/Campaigns/GGCampaigns/components/OwnersManagement';
import { ACTION_ACTIVATE, ACTION_ARCHIVE } from 'scenes/Campaigns/constants';
import {
  useActivateCampaigns,
  useArchiveCampaigns,
  useExportCampaigns,
} from 'scenes/Campaigns/GGCampaigns/data/mutations';

const CampaignsBulkActions = ({
  selectedValues,
  campaigns = [],
  onAddPromoCode,
  onChangeOwner,
}) => {
  const screenState = useScreenState();

  const [exportCampaigns] = useExportCampaigns();
  const [activateCampaigns] = useActivateCampaigns();
  const [archiveCampaigns] = useArchiveCampaigns();

  const selectedCampaigns = campaigns.filter(({ id }) =>
    selectedValues.includes(id)
  );

  const activeCampaigns = [];
  const archivedCampaigns = [];

  selectedCampaigns.forEach(({ id, name, actions = [] }) => {
    if (actions.includes(ACTION_ARCHIVE)) {
      archivedCampaigns.push({ id, name });
    } else if (actions.includes(ACTION_ACTIVATE)) {
      activeCampaigns.push({ id, name });
    }
  });

  const handleAddPromoCode = () => {
    onAddPromoCode(selectedCampaigns);
  };

  const handleChangeOwner = () => {
    onChangeOwner(selectedCampaigns);
  };
  const handleExport = async () => {
    const { filters, tableSettings, searchQuery } = screenState;

    const params = {
      filters,
      tableSettings,
      searchQuery,
    };

    if (selectedValues?.length) {
      params[CAMPAIGN_IDS] = selectedValues;
    }

    await exportCampaigns(params);
  };

  const handleActivate = async () => {
    await activateCampaigns({ status: 0, campaigns: activeCampaigns });
  };
  const handleArchive = async () => {
    await archiveCampaigns({ status: 1, campaigns: archivedCampaigns }); //we send "status id" what should be
  };

  return (
    <Actions>
      <Action
        button={true}
        label={'Add Promo Code'}
        onClick={handleAddPromoCode}
      />
      <Action button={true} label={'Export'} onClick={handleExport} />
      <Action
        button={true}
        label={'Change owner'}
        onClick={handleChangeOwner}
      />
      {activeCampaigns.length ? (
        <Action button={true} label={'Activate'} onClick={handleActivate} />
      ) : null}
      {archivedCampaigns.length ? (
        <Action button={true} label={'Archive'} onClick={handleArchive} />
      ) : null}
    </Actions>
  );
};

export default CampaignsBulkActions;
